import { useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div
      onClick={() => {
        history.push('/');
      }}
      style={{
        textDecoration: 'underline',
        cursor: 'pointer',
        textAlign: 'center',
        fontSize: '36px',
        color: 'red',
      }}
    >
      {t("error.ocurred")}
    </div>
  );
};

export default NotFound;
